import { useCallback } from 'react';
import { Form, FormProps } from 'components';
import { useCreateOrderMutation } from 'api/orders';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export interface OrderAddFormFieldType {
  clientId: string;
  deliveryCountryId: string;
  notes?: string;
}

export const useAddOrder = (props: { onModalStateChange: () => void }) => {
  const [form] = Form.useForm();
  const { onModalStateChange } = props;
  const [createOrder, { isLoading }] = useCreateOrderMutation();
  const { handleError, handleSuccess } = useNotificationMessages();

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish: FormProps<OrderAddFormFieldType>['onFinish'] = useCallback(
    async (values: OrderAddFormFieldType) => {
      try {
        const { data, error }: any = await createOrder(values);
        if (data?.success) {
          handleSuccess('The order was successfully created.');
          onModalStateChange();
          form.resetFields();
        } else if (error?.data) {
          const { data: errorData } = error.data;
          if (errorData) {
            Object.keys(errorData).forEach((key) => {
              handleError(errorData[key]);
            });
          } else {
            handleError(error.data?.error || 'Something went wrong!');
          }
        }
      } catch (err) {
        console.log(err, 'error');
        handleError('Something went wrong!');
      }
    },
    [createOrder, handleError, handleSuccess, form, onModalStateChange]
  );

  return {
    form,
    onCancel,
    onFinish,
    isLoading,
  };
};
